import React from 'react';
import {useParams} from 'react-router-dom';
import FormModal from "components/modals/FormModal";
import {InputText} from "primereact/inputtext";
import {
    useCreatePriorityPlannerMutation,
    useGetPriorityPlannerQuery,
    useListPriorityTasksQuery,
    useUpdatePriorityPlannerMutation
} from "../../apis/priorityApi";
import {InputTextarea} from "primereact/inputtextarea";
import PriorityTaskTable from "./PriorityTaskTable";
import PriorityTaskModal from "./PriorityTaskModal";
import {useUserProfileQuery} from "../../apis/authenticationApi";

const PriorityPlannerModal = () => {
    const { priority, task } = useParams();
    const {data: editPriorityPlanner, isFetching} = useGetPriorityPlannerQuery(priority);
    const {data: tasks, isLoading: isLoadingTasks} = useListPriorityTasksQuery();
    const [createPriorityPlanner] = useCreatePriorityPlannerMutation();
    const [updatePriorityPlanner] = useUpdatePriorityPlannerMutation();
    const {data: userProfile} = useUserProfileQuery();
    const canAddTasks = userProfile?.company?.role === "CompanyOwner" && !editPriorityPlanner?.completed;

    const handleSubmit = (data) => {
        if(!data.id || data.id === 'new') {
            createPriorityPlanner(data);
        }
        else {
            updatePriorityPlanner(data)
        }
    }

    const isNotCompleted = (tasks || []).some(task => task.parent === priority && task.taskStatus !== 'Done');

    if(isFetching || isLoadingTasks) {
        return (<></>);
    }
    else {
        return (<><FormModal width="75vw" type="Priority" completeLabel="Priority Fully Resolved" editObject={editPriorityPlanner || {name: ''}} showComplete={!isNotCompleted && !editPriorityPlanner.completed && editPriorityPlanner.id !== 'new'} handleSubmit={!editPriorityPlanner.completed && canAddTasks ? handleSubmit : undefined }
            renderForm={(formik) =>
                (<form onSubmit={formik.handleSubmit} className="formgrid grid">
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputText id="name" name="name" className="inputfield w-full" value={formik.values?.name} onChange={formik.handleChange} autoFocus disabled={userProfile?.company?.role !== "CompanyOwner"} />
                            <label htmlFor="name">Task Name/Description</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputTextarea autoResize id="notes" name="notes" className="inputfield w-full" value={formik.values?.notes} onChange={formik.handleChange} autoFocus disabled={userProfile?.company?.role !== "CompanyOwner"}/>
                            <label htmlFor="notes">Notes</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <PriorityTaskTable canAddTasks={canAddTasks} />
                    </div>
                </form>)
            }>
            </FormModal>
            {task && (<PriorityTaskModal />)}</>);
    }
}

export default PriorityPlannerModal;
